import { ref } from 'vue'
import axios from 'axios'
import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"

const error = ref(null)

export const sendSecurityCode = async (username) => {
    log("sendSecurityCode called with username: " + username)
    error.value = null
    try {
        const result = await axios.post(`${BASE_URL}/home/sendSecurityCode`, {
            username: username
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
        error.value = null
        log("sendSecurityCode result:")
        log(result.data)
        // Parse JSON string if needed
        if (typeof result.data === 'string') {
            return JSON.parse(result.data)
        }
        return result.data
    } catch (err) {
        log("Error in sendSecurityCode:")
        log(err)
        error.value = "Eroare la trimiterea codului"
        return { error: true, message: "Eroare la trimiterea codului" }
    }
}

const useSendSecurityCode = () => {
    return { error, sendSecurityCode }
}
export default useSendSecurityCode
